import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Overview from 'pages/Entity/Project/Overview/index';
import Performance from 'pages/Entity/Project/Performance/index';
import Territory from 'pages/Entity/Project/Territory';
import Charts from 'pages/Entity/Project/Charts/index';
import Social from 'pages/Entity/Project/Social/index';
import Airplay from 'pages/Entity/Project/Airplay/index';
import Audience from 'pages/Audience';

interface IProjectProps {
  location: any;
  pathPrefix: string;
  loading: boolean;
  artistMetadata: any;
}

const Project: React.FC<IProjectProps> = (props) => {
  const { location, pathPrefix, artistMetadata } = props;
  return (
    <Switch location={location}>
      <Route
        path={`${pathPrefix}/project/:entities/charts`}
        render={(routerProps): any => (
          <Charts {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/project/:entityId/social`}
        render={(routerProps): any => (
          <Social {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/project/:entities/overview`}
        render={(routerProps): any => (
          <Overview
            {...routerProps}
            pathPrefix={pathPrefix}
            artistMetadata={artistMetadata}
          />
        )}
      />
      <Route
        path={`${pathPrefix}/project/:entities/airplay`}
        render={(routerProps): any => (
          <Airplay {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/project/:entities/performance`}
        render={(routerProps): any => (
          <Performance
            {...routerProps}
            pathPrefix={pathPrefix}
            artistMetadata={artistMetadata}
          />
        )}
      />
      <Route
        path={`${pathPrefix}/project/:entityId/audience/ageGender`}
        render={(routerProps: any): any => <Audience {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/project/:entities/audience/territory`}
        render={(routerProps): any => <Territory {...routerProps} />}
      />
      <Redirect
        exact
        from={`${pathPrefix}/project/:entityId/audience`}
        to={`${pathPrefix}/project/:entityId/audience/ageGender`}
      />
    </Switch>
  );
};

export default Project;
